import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    expandedSupplierIds: [],
    reportDate: new Date(),
    filteredSupplierIds: [],
};
const supplierDebtReportSlice = createSlice({
    name: 'supplierDebtReport',
    initialState,
    reducers: {
        setExpandedSupplierIds: (state, action) => {
            state.expandedSupplierIds = [...action.payload];
        },
        addExpandedSupplierId: (state, action) => {
            state.expandedSupplierIds.push(action.payload);
        },
        deleteExpandedSupplierId: (state, action) => {
            state.expandedSupplierIds = state.expandedSupplierIds.filter((id) => id !== action.payload);
        },
        setFilteredSupplierIds: (state, action) => {
            state.filteredSupplierIds = [...action.payload];
        },
        setReportDate: (state, action) => {
            state.reportDate = action.payload;
        },
    },
});
export const { actions: supplierDebtReportActions, reducer: supplierDebtReportReducer } = supplierDebtReportSlice;
